export const important = (cssValue: string | number) => `${cssValue}!important`
export const and = (...classNames: string[]) => `&.${classNames.join('.')}`
export const inside = (...classNames: string[]) => `& .${classNames.join(' .')}`
